// eslint-disable-next-line import/no-mutable-exports
let envVariables = {
  REACT_APP_IN_PRODUCTION: false,
  REACT_APP_API_BASE_URL: "https://api.dev-manifest.com/manifest",
  REACT_APP_ZOHO_BOOKING_URL: "https://manifest1.zohobookings.com/portal-embed#/4756981000000043054",
  REACT_APP_EMPLOYER_SEARCH_URL: "https://employer-search.dev-manifest.com",
  REACT_APP_BEACON_ID: "cca5af6b-c437-4a5d-8374-070f20bd556e",
  REACT_APP_HEAP_ID: "92715569",
  REACT_APP_DEBUG: process.env.REACT_APP_DEBUG === "true",
  REACT_APP_LOGIN_CODES: ["300308"],
};

const testEnvVariables = {
  ...envVariables,
};

// Allow for playwright to use this file as well for E2E e2e (window is not defined)
let origin = "local";
try {
  origin = window.location.origin;
} catch (e) {
  // Do nothing
}

const isLocalEnvironment = () => {
  // return true;
  return origin.indexOf("localhost") > -1 || origin.indexOf("127.0.0.1") > -1 || origin.indexOf("10.0.0.9") > -1;
};

const isDevelopmentEnvironment = () => {
  return (
    ["https://dev.dev-manifest.com"].includes(origin) ||
    origin.indexOf("localhost") > -1 ||
    origin.indexOf("127.0.0.1") > -1 ||
    origin.indexOf("10.0.0.9") > -1
  );
};

const isStagingEnvironment = () => {
  return origin.indexOf("staging") > -1;
};

const isProdEnvironment = () => {
  return origin.indexOf("secure") > -1;
};

const isE2EEnvironment = () => {
  if (!localStorage) return false;
  return localStorage.getItem("isE2ETest") === "true";
};

if (isStagingEnvironment()) {
  envVariables = {
    ...envVariables,
    REACT_APP_DEBUG: false,
    REACT_APP_API_BASE_URL: "https://staging-api.dev-manifest.com/manifest",
    // REACT_APP_EMPLOYER_SEARCH_URL: "https://employer-search.dev-manifest.com",
    REACT_APP_EMPLOYER_SEARCH_URL: "https://employer-search-staging.dev-manifest.com",
  };
}

if (isProdEnvironment()) {
  envVariables = {
    ...envVariables,
    REACT_APP_DEBUG: false,
    REACT_APP_IN_PRODUCTION: true,
    REACT_APP_ZOHO_BOOKING_URL: "https://manifest.zohobookings.com/portal-embed#/4630522000000080008",
    REACT_APP_API_BASE_URL: "https://api.secure.usemanifest.com/manifest",
    REACT_APP_EMPLOYER_SEARCH_URL: "https://employersearch.secure.usemanifest.com",

    // USE STAGING UNTIL ENV IS FIXED FOR PROD
    // REACT_APP_EMPLOYER_SEARCH_URL: "https://employer-search-staging.dev-manifest.com",
    REACT_APP_HEAP_ID: "1295109176",
    REACT_APP_LOGIN_CODES: ["091004"],
  };
}

function getEnvironmentName() {
  if (isProdEnvironment()) {
    return "prod";
  }
  if (isStagingEnvironment()) {
    return "staging";
  }
  return "development";
}

function getEnvironmentUrl() {
  const environment = getEnvironmentName();
  if (environment === "prod") return "https://secure.usemanifest.com";
  if (environment === "staging") return "https://staging.dev-manifest.com";
  if (isLocalEnvironment()) return "http://localhost:3000";
  return "https://dev.dev-manifest.com";
}

function getWidgetEnvironmentUrl() {
  const environment = getEnvironmentName();
  if (environment === "prod") return "https://widgets.usemanifest.com";
  if (environment === "staging") return "https://staging-widgets.dev-manifest.com";
  if (isLocalEnvironment()) return "http://localhost:3001";
  if (environment === "development") return "https://dev-widgets.dev-manifest.com";
}

// Expose a manifestTesting object that we can use in our E2E tests
try {
  window.manifestTesting = {
    baseUrl: envVariables.REACT_APP_API_BASE_URL,
    employerSearchUrl: envVariables.REACT_APP_EMPLOYER_SEARCH_URL,
    lastInitiatedTransferId: -1,
  };
} catch (e) {
  // Do nothing
}

export {
  getEnvironmentUrl,
  getEnvironmentName,
  getWidgetEnvironmentUrl,
  isLocalEnvironment,
  isDevelopmentEnvironment,
  isProdEnvironment,
  isStagingEnvironment,
  isE2EEnvironment,
  envVariables,
  testEnvVariables,
};
